import React, { useState, useEffect } from 'react';
import { getFormations } from '../../../services/formation.service';
import cn from 'classnames';
import Card from '../../../components/Card';
import TextInput from '../../../components/TextInput';
import Dropdown from '../../../components/Dropdown';
import Switch from '../../../components/Switch';
import styles from './StudyInformations.module.sass';

const SITUATION_OPTIONS = [
    { value: '1', title: '1 - Scolaire' },
    { value: '2', title: '2 - Prépa apprentissage' },
    { value: '3', title: '3 - Etudiant' },
    { value: '4', title: '4 - Contrat d\'apprentissage' },
    { value: '5', title: '5 - Contrat de professionnalisation' },
    { value: '6', title: '6 - Contrat aidé' },
    { value: '7', title: '7 - En formation au CFA avant signature d\'un contrat d\'apprentissage (L6222-12-1 du code du travail)' },
    { value: '8', title: '8 - En formation, au CFA, sans contrat, suite à rupture (5° de L6231-2 du code du travail)' },
    { value: '9', title: '9 - Stagiaire de la formation professionnelle' },
    { value: '10', title: '10 - Salarié' },
    { value: '11', title: '11 - Personne à la recherche d\'un emploi (inscrite ou non au Pôle Emploi)' },
    { value: '12', title: '12 - Inactif' }
];

const CLASS_OPTIONS = [
    { value: '1', title: "1 - L'apprenti a suivi la dernière année du cycle de formation et a obtenu le diplôme" },
    { value: '11', title: "11 - l'apprenti a suivi la 1ère année du cycle et l'a validé (examens réusss mais année non diplômantes)" },
    { value: '12', title: "12 - L'apprenti a suivi laa 1ère année du cycle mais ne l'a pas validée (échec aux examens, interruption ou abandon de formation)" },
    { value: '21', title: "21 - l'apprenti a suiv la 2è année de cyle et l'a validée (examens réusss mais année non diplômantes)" },
    { value: '22', title: "22 - L'apprenti a suivi la 2è année du cycle mais ne l'a pas validée (échec aux examens, interruption ou abandon de formation)" },
    { value: '31', title: "31 - L'apprenti a suivi la 3ème année du cycle et l'a validée (examens réusss mais année non diplômantes, cycle adapté)" },
    { value: '32', title: "32 - L'apprenti a suivi la 3ème année du cycle mais ne l'a pas validée (échec aux examens, interruption ou abandon de formation)" },
    { value: '40', title: "40 - l'apprenti a achevé le 1er cycle de l'enseignement secondaire (collège)" },
    { value: '41', title: "41 - l'apprenti a interrompu ses études en classe de 3è" },
    { value: '42', title: "42 - l'apprenti a abandonné ses études en classe de 4è" }
];

const DIPLOMA_OPTIONS = [
    { value: '13', title: "13 - Aucun diplôme ni titre professionnel" },
    { value: '25', title: "25 - Diplôme national du brevet (DNB)" },
    { value: '26', title: "26 - Certificat de formation générale" },
    { value: '38', title: "38 - Autre diplôme ou titre de niveau CAP/BEP" },
    { value: '35', title: "35 - Mention complémentaire" },
    { value: '34', title: "34 - BEP" },
    { value: '33', title: "33 - CAP" },
    { value: '49', title: "49 - Autre diplôme ou titre de niveau bac" },
    { value: '43', title: "43 - Baccalauréat Technologique" },
    { value: '42', title: "42 - Baccalauréat Général" },
    { value: '41', title: "41 - Baccalauréat Professionnel" },
    { value: '58', title: "58 - Autre diplôme ou titre de niveau bac+2" },
    { value: '55', title: "55 - Diplôme Universitaire de technologie" },
    { value: '54', title: "54 - Brevet de Techniciens supérieurs" },
    { value: '69', title: "69 - Autre diplôme ou titre de niveau bac +3 ou 4" },
    { value: '64', title: "64 - Bachelor Universitaire  ed technologie BUT" },
    { value: '63', title: "63 - Licence générale" },
    { value: '62', title: "62 - Licence professionnelle" },
    { value: '61', title: "61 - 1ère année de Master" },
    { value: '79', title: "79 - Autre diplôme ou titre de niveau bac +5 ou plus" },
    { value: '74', title: "74 - Diplôme d'ingénieur, diplôme de commerce" },
    { value: '73', title: "73 - Master indifférencié" },
    { value: '72', title: "72 - Master recherche/DEA" },
    { value: '71', title: "71 - Master professionnel/DESS" },
    { value: '80', title: "80 - Doctorat" }
];

const HIGHEST_DIPLOMA_OPTIONS = [
    { value: '13', title: "13 - Aucun diplôme ni titre professionnel" },
    { value: '25', title: "25 - Diplôme national du brevet (DNB)" },
    { value: '26', title: "26 - Certificat de formation générale" },
    { value: '38', title: "38 - Autre diplôme ou titre de niveau CAP/BEP" },
    { value: '35', title: "35 - Mention complémentaire" },
    { value: '34', title: "34 - BEP" },
    { value: '33', title: "33 - CAP" },
    { value: '49', title: "49 - Autre diplôme ou titre de niveau bac" },
    { value: '43', title: "43 - Baccalauréat Technologique" },
    { value: '42', title: "42 - Baccalauréat Général" },
    { value: '41', title: "41 - Baccalauréat Professionnel" },
    { value: '58', title: "58 - Autre diplôme ou titre de niveau bac+2" },
    { value: '55', title: "55 - Diplôme Universitaire de technologie" },
    { value: '54', title: "54 - Brevet de Techniciens supérieurs" },
    { value: '69', title: "69 - Autre diplôme ou titre de niveau bac +3 ou 4" },
    { value: '64', title: "64 - Bachelor Universitaire  ed technologie BUT" },
    { value: '63', title: "63 - Licence générale" },
    { value: '62', title: "62 - Licence professionnelle" },
    { value: '61', title: "61 - 1ère année de Master" },
    { value: '79', title: "79 - Autre diplôme ou titre de niveau bac +5 ou plus" },
    { value: '74', title: "74 - Diplôme d'ingénieur, diplôme de commerce" },
    { value: '73', title: "73 - Master indifférencié" },
    { value: '72', title: "72 - Master recherche/DEA" },
    { value: '71', title: "71 - Master professionnel/DESS" },
    { value: '80', title: "80 - Doctorat" }
];

const StudyInformations = ({ student, onStudentChange, onDropdownChange, onSwitchChange, loading }) => {
    const [formations, setFormations] = useState([]);
    const [loadingFormations, setLoadingFormations] = useState(false);

    useEffect(() => {
        const fetchFormations = async () => {
            setLoadingFormations(true);
            try {
                const data = await getFormations();
                setFormations(data || []);
            } catch (error) {
                console.error("Erreur lors de la récupération des formations", error);
                setFormations([]);
            } finally {
                setLoadingFormations(false);
            }
        };

        fetchFormations();
    }, []);

    const formationOptions = formations.map(f => ({ value: f.id, title: f.exact_title_of_qualification }));
    return (
        <Card className={styles.card} title="Études & Projet" classTitle="title-green">

            <div className={styles.field}>
                {loadingFormations ? (
                    <p>Chargement des formations...</p>
                ) : (
                    <Dropdown
                        className={styles.dropdown}
                        label="Formation visée"
                        name="formation"
                        options={formationOptions}
                        value={formationOptions.find(opt => opt.value === student?.formation) || ''}
                        setValue={(option) => onDropdownChange('formation', option.value)}
                        required
                    />
                )}
            </div>

            <div className={styles.group}>

                <div className={styles.field}>
                    <Dropdown
                        className={styles.dropdown}
                        label="Situation avant contrat"
                        name="situation_before_contract"
                        options={SITUATION_OPTIONS}
                        value={SITUATION_OPTIONS.find(opt => opt.value === student?.situation_before_contract) || ''}
                        setValue={(option) => onDropdownChange('situation_before_contract', option.value)}
                    />
                </div>

                <div className={styles.field}>
                    <Dropdown
                        className={styles.dropdown}
                        label="Dernière classe"
                        name="last_class"
                        options={CLASS_OPTIONS}
                        value={CLASS_OPTIONS.find(opt => opt.value === student?.last_class) || ''}
                        setValue={(option) => onDropdownChange('last_class', option.value)}
                    />
                </div>


                <div className={styles.field}>
                    <Dropdown
                        className={styles.dropdown}
                        label="Dernier diplôme préparé"
                        name="last_prepared_diploma"
                        options={DIPLOMA_OPTIONS}
                        value={DIPLOMA_OPTIONS.find(opt => opt.value === student?.last_prepared_diploma) || ''}
                        setValue={(option) => onDropdownChange('last_prepared_diploma', option.value)}
                    />
                </div>

                <div className={styles.field}>
                    <Dropdown
                        className={styles.dropdown}
                        label="Diplôme ou titre le plus élevé obtenu"
                        name="highest_diploma_obtained"
                        options={HIGHEST_DIPLOMA_OPTIONS}
                        value={HIGHEST_DIPLOMA_OPTIONS.find(opt => opt.value === student?.highest_diploma_obtained) || ''}
                        setValue={(option) => onDropdownChange('highest_diploma_obtained', option.value)}
                    />
                </div>

                <TextInput
                    className={styles.field}
                    label="Intitulé précis du dernier diplôme ou titre obtenu"
                    name="highest_diploma_title"
                    type="text"
                    placeholder="Intitulé précis du diplôme"
                    value={student?.highest_diploma_title || ''}
                    onChange={onStudentChange}
                />

                <div className={styles.field} style={{ display: 'flex', alignItems: 'center' }}>
                    <span style={{ marginLeft: '10px' }}>Projet de création ou de reprise d’entreprise :</span>
                    <Switch
                        name="is_business_owner"
                        value={student?.is_business_owner || false}
                        className={styles.switch}
                        onChange={(value) => onSwitchChange('is_business_owner', value)}
                    />
                </div>

            </div>
            <div className={styles.divider}></div>

            <div className={styles.actions}>
                <button
                    className={cn("button", styles.button)}
                    type="submit"
                    disabled={loading}
                >
                    {loading ? "Création en cours..." : "Créer l'élève"}
                </button>
            </div>
        </Card>
    );
};

export default StudyInformations;